module.exports = __webpack_public_path__ + "static/basketball-19b2a75cb10b6d1cdd62c9f84fa63037.jpg";